module.exports = __webpack_public_path__ + "static/media/2805a44f849d578506544caae12f3297_html_fbf8a0a6c0a5c8be.2f0eed89.png";